<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="5" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
              style="width: 270px"
            />
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="校部:">
            <el-select v-model="table.where.branchId" placeholder="请选择校部" clearable @change="handleBranchChange">
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange">
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="班级:">
            <el-select v-model="table.where.classId" placeholder="请选择班级" clearable @change="$forceUpdate()">
              <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="exportInfo" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="rank" label="排名" show-overflow-tooltip align="center">
          <template slot-scope="{ row }"> 第{{ row.rank }}名 </template>
        </el-table-column>
        <el-table-column prop="score" label="总分" show-overflow-tooltip align="center" />
      </template>
    </ele-data-table>
  </div>
</template>

<script>
  import { exportClassStStatistics, selectionList } from '@/config/yizhongDong/examine';

  export default {
    name: 'Class',
    data() {
      return {
        table: {
          // 表格配置
          url: '/yzdAccess/classAccessStatisticsPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        branchList: [],
        gradeList: [],
        classList: [],
        projectList: [],
        date: null,
      };
    },
    created() {
      // 初始化加载校部列表
      this.loadBranchList();
    },
    methods: {
      // 加载校部列表
      async loadBranchList() {
        try {
          const res = await selectionList({ type: 1, projectType: 2 });
          if (res.data.resCode == 200) {
            this.branchList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载校部列表失败:', error);
        }
      },
      // 加载年级列表
      async loadGradeList(branchId) {
        if (!branchId) {
          this.gradeList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 2, projectType: 2, id: branchId });
          if (res.data.resCode == 200) {
            this.gradeList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载年级列表失败:', error);
        }
      },
      // 加载班级列表
      async loadClassList(gradeId) {
        if (!gradeId) {
          this.classList = [];
          return;
        }
        try {
          const res = await selectionList({ type: 4, projectType: 2, id: gradeId });
          if (res.data.resCode == 200) {
            this.classList = res.data.data || [];
          }
        } catch (error) {
          console.error('加载班级列表失败:', error);
        }
      },
      // 选择校部时
      handleBranchChange(branchId) {
        // 清空下级选项
        this.table.where.gradeId = undefined;
        this.table.where.classId = undefined;
        this.gradeList = [];
        this.classList = [];

        // 加载年级列表
        if (branchId) {
          this.loadGradeList(branchId);
        }
      },
      // 选择年级时
      handleGradeChange(gradeId) {
        // 清空下级选项
        this.table.where.classId = undefined;
        this.classList = [];
        // 加载班级列表
        if (gradeId) {
          this.loadClassList(gradeId);
        }
      },
      // 重置表单
      handleReset() {
        this.table.where = {};
        this.date = null;
        this.gradeList = [];
        this.classList = [];
        this.$refs.table.reload();
      },
      handleDateChange(value) {
        this.table.where.startTime = value[0];
        this.table.where.endTime = value[1];
      },
      // 导出数据
      exportInfo() {
        exportClassStStatistics(this.table.where).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
